<template>
  <div>
    <el-page-header @back="goBack" content="样式配置"></el-page-header>
    <div class="topic-outer" style="border: 0;">
      <div class="appraisal-center fonts">
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>创意ID：</span>
            <span class="glay">{{ detalisObj.taid }}</span>
          </div>
          <div class="fl1">
            <span> 广告计划：</span>
            <span class="glay">默认</span>
          </div>
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>测评题：</span>
            <span class="glay">{{ detalisObj.bizName }}</span>
          </div>
          <div class="fl1">
            <span>标识：</span>
            <span class="glay">{{ detalisObj.bizUid}}</span>
          </div>
        </div>
        <div class="flex-box pub-line">
          <div class="fl1">
            <span>投放渠道：</span>
            <span class="glay">{{ detalisObj.channelName }}（{{detalisObj.channelCode}} ）</span>
          </div>
          <div class="fl1">
            <span>应用：</span>
            <span class="glay">{{ detalisObj.appName }}（{{detalisObj.swid}} ）</span>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <el-tabs v-model="type" @tab-click="handleClick">
        <el-tab-pane label="落地页" name="Landing"></el-tab-pane>
        <el-tab-pane label="支付流程" name="payment"></el-tab-pane>
      </el-tabs>
      <div class="one_box">
        <el-form ref="form" :model="form" label-width="100px">
          <template v-if="type=='Landing'">
            <div class="class_name">落地页</div>
            <el-form-item label="背景色：">
              <el-input style="width:240px;margin-right: 20px" v-model="form.detailBgcolor" placeholder="页面背景色"></el-input>
            </el-form-item>
            <el-form-item label="主图：">
              <div class="diplay" style="margin-right: 10px">
                <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in themeList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 125px; height: 64px;  border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getThemePolicy"
                  />
                </span>
                  <div
                      class="up-btn"
                      style="width: 125px; height: 64px; line-height: 70px"
                      @click="getThemePolicy"
                      v-if="isThemeMoer"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input
                    type="file"
                    ref="themefile"
                    @change="getThemeFile"
                    accept="image/png,image/jpg"
                />
              </div>
            </el-form-item>
            <el-form-item label="详情图：">
              <div class="diplay" style="margin-right: 10px">
                <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in detailImgList"
                    :key="index"
                    class="slideshow"
                >
                  <div class="icon-close" @click="removeDetailUploading(index)">
                    <i class="el-icon-close"></i>
                  </div>
                  <el-image
                      style="width: 125px; height: 64px;  border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getDetailBanner"
                  />
                </span>
                  <div
                      v-if="detailImgList.length<=10"
                      class="up-btn"
                      style="width: 125px; height: 64px;  line-height: 70px"
                      @click="getDetailBanner"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input
                    type="file"
                    ref="fileDetailBanner"
                    @change="getDetailFileBanner"
                    accept="image/png,image/jpg"
                />
              </div>
            </el-form-item>
            <div class="congT_dis">
              <el-form-item label="文字颜色：">
                <el-input style="width:240px" v-model="form.detailFontbgcolor" placeholder="测试、报告、题目数和时间"></el-input>
              </el-form-item>
              <el-form-item label="背景色：">
                <el-input style="width:240px" v-model="form.detailBgimg" placeholder="文字背景色"></el-input>
              </el-form-item>
            </div>
            <div class="class_name">落地页按钮</div>
            <el-form-item label="类型：">
              <el-radio-group v-model="form.btnType">
                <el-radio label="text">文字</el-radio>
                <el-radio label="img">图片</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="">
              <div class="congT_dis" v-if="form.btnType=='text'">
                <el-input style="width:240px;margin-right: 20px" v-model="form.btnText" placeholder="按钮文字"></el-input>
                <el-input style="width:240px" v-model="form.btnFontcolor" placeholder="按钮文字颜色"></el-input>
              </div>
              <div class="img_box_info_tba" v-if="form.btnType=='img'">
                <div class="diplay" style="margin-right: 10px">
                  <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 145px; height: 35px; border-radius: 6px"
                      :src="imgUrl"
                      fit="fill"
                      @click="getPolicy"
                  />
                </span>
                    <div
                        class="up-btn"
                        style="width: 145px; height: 35px; line-height: 40px"
                        @click="getPolicy"
                        v-if="isMoer"
                    >
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                  <input
                      type="file"
                      ref="file"
                      @change="getFile"
                      accept="image/png,image/jpg"
                  />
                </div>
              </div>
            </el-form-item>
            <el-form-item label="背景色：">
              <el-input style="width:240px;margin-right: 20px" v-model="form.btnBgcolor"
                        placeholder="按钮区域背景色"></el-input>
            </el-form-item>
            <el-form-item label="动效：">
              <el-radio-group v-model="form.btnEffect">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </template>
          <template v-if="type=='payment'">
            <div class="class_name">支付选择页</div>
            <el-form-item label="背景图：">
              <div class="diplay" style="margin-right: 10px">
                <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in toBePaidList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 125px; height: 64px;  border-radius: 6px"
                      :src="imgUrl"
                      fit="fill"
                      @click="getToBePolicy"
                  />
                </span>
                  <div
                      class="up-btn"
                      style="width: 125px; height: 64px; line-height: 70px"
                      @click="getToBePolicy"
                      v-if="isToBePaidMoer"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input
                    type="file"
                    ref="tobefile"
                    @change="getToBeFile"
                    accept="image/png,image/jpg"
                />
              </div>
            </el-form-item>
            <div class="congT_dis">
              <el-form-item label="文字颜色：">
                <el-input style="width:240px" v-model="form.unpayFontcolor" placeholder="答题数、用时、年龄"></el-input>
              </el-form-item>
              <el-form-item label="背景色：">
                <el-input style="width:240px" v-model="form.unpayBgcolor" placeholder="页面背景色"></el-input>
              </el-form-item>
            </div>
            <div class="class_name">支付页</div>
            <el-form-item label="背景图：">
              <div class="diplay" style="margin-right: 10px">
                <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in paymentList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 125px; height: 64px;  border-radius: 6px"
                      :src="imgUrl"
                      fit="fill"
                      @click="getPayPolicy"
                  />
                </span>
                  <div
                      class="up-btn"
                      style="width: 125px; height: 64px; line-height: 70px"
                      @click="getPayPolicy"
                      v-if="isPaymentMoer"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input
                    type="file"
                    ref="payfile"
                    @change="getPayFile"
                    accept="image/png,image/jpg"
                />
              </div>
            </el-form-item>
            <el-form-item label="支付引导：">
              <div class="diplay" style="margin-right: 10px">
                <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListBanner"
                    :key="index"
                    class="slideshow"
                >
                  <div class="icon-close" @click="removeUploading(index)">
                    <i class="el-icon-close"></i>
                  </div>
                  <el-image
                      style="width: 125px; height: 64px;  border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicyBanner"
                  />
                </span>
                  <div
                      v-if="srcListBanner.length<=10"
                      class="up-btn"
                      style="width: 125px; height: 64px;  line-height: 70px"
                      @click="getPolicyBanner"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input
                    type="file"
                    ref="fileBanner"
                    @change="getFileBanner"
                    accept="image/png,image/jpg"
                />
              </div>
            </el-form-item>
            <el-form-item label="报告引导：">
              <div class="diplay" style="margin-right: 10px">
                <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in reportList"
                    :key="index"
                    class="slideshow"
                >
                  <div class="icon-close" @click="removeReportUploading(index)">
                    <i class="el-icon-close"></i>
                  </div>
                  <el-image
                      style="width: 125px; height: 64px;  border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicyReport"
                  />
                </span>
                  <div
                      v-if="reportList.length<=10"
                      class="up-btn"
                      style="width: 125px; height: 64px;  line-height: 70px"
                      @click="getPolicyReport"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input
                    type="file"
                    ref="fileReport"
                    @change="getFileReport"
                    accept="image/png,image/jpg"
                />
              </div>
            </el-form-item>
            <div class="congT_dis">
              <el-form-item label="文字颜色：">
                <el-input style="width:240px" v-model="form.payFontcolor" placeholder="答题数、用时、年龄"></el-input>
              </el-form-item>
              <el-form-item label="背景色：">
                <el-input style="width:240px" v-model="form.payBgcolor" placeholder="页面背景色"></el-input>
              </el-form-item>
            </div>
            <div class="class_name">支付成功页</div>
            <el-form-item label="背景图：">
              <div class="diplay" style="margin-right: 10px">
                <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in successList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 125px; height: 64px;  border-radius: 6px"
                      :src="imgUrl"
                      fit="fill"
                      @click="getSuccessPolicy"
                  />
                </span>
                  <div
                      class="up-btn"
                      style="width: 125px; height: 64px; line-height: 70px"
                      @click="getSuccessPolicy"
                      v-if="isSuccessMoer"
                  >
                    <i class="el-icon-plus"></i>
                  </div>
                </div>
                <input
                    type="file"
                    ref="successfile"
                    @change="getSuccessFile"
                    accept="image/png,image/jpg"
                />
              </div>
            </el-form-item>
            <div class="congT_dis">
              <el-form-item label="文字颜色：">
                <el-input style="width:240px" v-model="form.sucpayFontcolor" placeholder="答题数、用时、年龄"></el-input>
              </el-form-item>
              <el-form-item label="背景色：">
                <el-input style="width:240px" v-model="form.sucpayBgcolor" placeholder="页面背景色"></el-input>
              </el-form-item>
            </div>
            <el-form-item label="报告按钮：">
              <div class="congT_dis">
                <el-input style="width:240px;margin-right: 20px" v-model="form.sucpayBtnFontcolor"
                          placeholder="按钮文字颜色"></el-input>
                <el-input style="width:240px" v-model="form.sucpayBtnBgcolor" placeholder="按钮背景颜色"></el-input>
              </div>
            </el-form-item>
          </template>
          <el-button style="width: 180px;margin-left: 100px" type="primary" @click="configHandleEdit">提交</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import {ossUpload} from "@utils/filters/upload";

export default {
  name: "configureView",
  data() {
    return {
      detalisObj: {},
      type: 'Landing',
      clientId: 't200',
      form: {
        btnType: 'text',
        btnEffect: 1
      },

      srcList: [],
      isMoer: true,

      toBePaidList: [],
      isToBePaidMoer: true,

      paymentList: [],
      isPaymentMoer: true,

      srcListBanner: [],
      reportList: [],

      successList: [],
      isSuccessMoer: true,

      themeList:[],
      isThemeMoer: true,

      detailImgList:[]
    }
  },
  mounted() {
    this.getAppraisalData()
  },
  methods: {

    /**
     * 提交配置信息
     */
    configHandleEdit() {
      this.form.advertId = this.detalisObj.advertId
      this.$confirm("确认保存数据, 是否继续?", "提示", {
        type: "info",
      }).then(async () => {
        if(this.type=='Landing'){
          const {data: resData} = await this.$post(
              "/advert/style/config/detail/info",
              this.form,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("保存成功!");
        }else {
          const {data: resData} = await this.$post(
              "/advert/style/config/pay/info",
              this.form,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.$message.success("保存成功!");
        }

      })
    },

    /**
     * 获取配置详情
     */
    async getStyleConfig() {
      this.loading = true;
      const {data: resData} = await this.$get(
          `advert/style/config/info/${this.detalisObj.advertId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      if (resData.data) {
        if (resData.data.btnImg) {
          this.srcList.push(resData.data.btnImg)
          this.isMoer = false
        }
        if (resData.data.sucpayImg) {
          this.successList.push(resData.data.sucpayImg)
          this.isSuccessMoer = false
        }
        if (resData.data.payIntro) {
          this.srcListBanner = JSON.parse(JSON.stringify(resData.data.payIntro))
        }
        if (resData.data.payIntro2) {
          this.reportList = JSON.parse(JSON.stringify(resData.data.payIntro2))
        }
        if (resData.data.unpayImg) {
          this.toBePaidList.push(resData.data.unpayImg)
          this.isToBePaidMoer = false
        }
        if (resData.data.payImg) {
          this.paymentList.push(resData.data.payImg)
          this.isPaymentMoer = false
        }
        if (resData.data.detailBanner) {
          this.themeList.push(resData.data.detailBanner)
          this.isThemeMoer = false
        }
        if (resData.data.detailImg) {
          this.detailImgList = JSON.parse(JSON.stringify(resData.data.detailImg))
        }
        this.form = JSON.parse(JSON.stringify(resData.data));
      }
    },
    //落地主图
    getThemePolicy() {
      this.$refs.themefile.dispatchEvent(new MouseEvent("click"));
    },
    async getThemeFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.themefile.files[0],
          resData.data,
          "one", //'more','one'
          this.themeList
      );
      this.isThemeMoer = false;
      this.themeList = addRoutes;
      this.form.detailBanner = this.themeList[0];
    },
    //落地页详情图
    getDetailBanner() {
      this.$refs.fileDetailBanner.dispatchEvent(new MouseEvent("click"));
    },
    async getDetailFileBanner() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });

      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileDetailBanner.files[0],
          resData.data,
          "more", //'more','one'
          this.detailImgList
      );
      // this.isMoerBanner = false;
      this.detailImgList = addRoutes;
      this.form.detailImg = this.detailImgList;
    },

    removeDetailUploading(index) {
      this.detailImgList.splice(index, 1);
      this.form.detailImg = this.detailImgList;
    },
    //落地按钮图
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.form.btnImg = this.srcList[0];
    },

    //支付成功页背景图
    getSuccessPolicy() {
      this.$refs.successfile.dispatchEvent(new MouseEvent("click"));
    },
    async getSuccessFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.successfile.files[0],
          resData.data,
          "one", //'more','one'
          this.successList
      );
      this.isSuccessMoer = false;
      this.successList = addRoutes;
      this.form.sucpayImg = this.successList[0];
    },

    //支付页背景图
    getPayPolicy() {
      this.$refs.payfile.dispatchEvent(new MouseEvent("click"));
    },
    async getPayFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.payfile.files[0],
          resData.data,
          "one", //'more','one'
          this.paymentList
      );
      this.isPaymentMoer = false;
      this.paymentList = addRoutes;
      this.form.payImg = this.paymentList[0];
    },
    //支付引导
    getPolicyBanner() {
      this.$refs.fileBanner.dispatchEvent(new MouseEvent("click"));
    },
    async getFileBanner() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });

      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileBanner.files[0],
          resData.data,
          "more", //'more','one'
          this.srcListBanner
      );
      this.isMoerBanner = false;
      this.srcListBanner = addRoutes;
      this.form.payIntro = this.srcListBanner;
    },

    removeUploading(index) {
      this.srcListBanner.splice(index, 1);
      this.form.payIntro = this.srcListBanner;
    },
    //报告引导
    getPolicyReport() {
      this.$refs.fileReport.dispatchEvent(new MouseEvent("click"));
    },
    async getFileReport() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });

      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileReport.files[0],
          resData.data,
          "more", //'more','one'
          this.reportList
      );
      this.isMoerBanner = false;
      this.reportList = addRoutes;
      this.form.payIntro2 = this.reportList;
    },

    removeReportUploading(index) {
      this.reportList.splice(index, 1);
      this.form.payIntro = this.reportList;
    },

    //待支付成功页背景图
    getToBePolicy() {

      this.$refs.tobefile.dispatchEvent(new MouseEvent("click"));
    },
    async getToBeFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.tobefile.files[0],
          resData.data,
          "one", //'more','one'
          this.toBePaidList
      );
      this.isToBePaidMoer = false;
      this.toBePaidList = addRoutes;
      this.form.unpayImg = this.toBePaidList[0];
    },

    handleClick() {
      // this.form = JSON.parse(JSON.stringify({btnType: 'text', btnEffect: 1}))
      // this.srcList = []
      // this.isMoer = true
      // this.toBePaidList = []
      // this.isToBePaidMoer = true
      // this.paymentList = []
      // this.isPaymentMoer = true
      // this.srcListBanner = []
      // this.reportList = []
      // this.successList = []
      // this.isSuccessMoer = true
      // this.getStyleConfig()
    },

    /**
     * 获取测评详情
     */
    async getAppraisalData() {
      this.loading = true;

      const {data: resData} = await this.$get(
          `advert/info/${this.$route.query.advertId}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.detalisObj = resData.data;
      this.getStyleConfig()
    },
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style scoped lang="scss">
.appraisal-center {
  width: 90%;
  margin: 0 auto;
}

.fonts {
  font-size: 14px;
}

.topic-outer {
  width: 800px;
  background: #fff;
  overflow: hidden;
  margin-top: 20px;
  padding-bottom: 30px;
}

.flex-box {
  display: -webkit-box;
  display: -moz-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
}

.fl1 {
  flex: 1;
  -webkit-flex: 1;
}

.glay {
  color: #8492a6;

  i {
    font-style: normal;
    color: #f56c6c;
  }
}

.pub-line {
  margin-top: 30px;
}

.congT_dis {
  display: flex;
  align-items: center;
}

.one_box {
}

.img_box_info_tba {
}

.class_name {
  font-size: 13px;
  color: #333333;
  font-weight: 700;
  margin-bottom: 20px;
}



</style>

<style>
.content .el-tabs__nav-wrap{
  width: 270px !important;
}
.content .el-tabs__nav{
  width: 100% !important;
}
.content .el-tabs__item {
   width: 50%;
   padding: 0 !important;
  text-align: center;
  font-weight: 600;
}
.content .el-tabs__active-bar{
  height: 1px !important;
}
.content .el-tabs__nav-wrap::after{
  height: 1px !important;
}
/*.content .el-tabs__nav-scroll{*/
/*  width: 270px !important;*/
/*}*/
</style>